import * as React from 'react';
import { Stack, Typography } from '@mui/material';
import cookieStorage from '../../services/cookie-storage';
import { setLanguage } from '../../action/language';
import { useDispatch, useSelector } from "react-redux";
import ApiService from '../../services/api-service';
import TranslateIcon from "@mui/icons-material/Translate";
import { Images } from '../../assets/common';
import { useTranslation } from "react-i18next";
import { Box } from '@material-ui/core';

export default function SkDrawerSettings(props) {
    const [menuLang, setMenuLang] = React.useState(false);
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation("common");
    const { availableLanguages, language } = useSelector(
        (state) => state.language
    );

    const handleLangChange = async (language) => {
        setMenuLang(false);
        try {
            const response = await ApiService.LANGUAGE(
                `language=${language}&class=web`
            );
            const { availableLanguages, languageObject, selectedLanguage, token } = response.result;

            if (token) cookieStorage.createCookie("Authorization", token, 1);
            dispatch(
                setLanguage({
                    language: selectedLanguage,
                    languageObject: languageObject,
                    availableLanguages: availableLanguages,
                })
            );
            window.location.reload();
        } catch (error) {}
    };
    const getCode = () => {
        const lng = availableLanguages.filter(
            (available) => available.code === language
        );
        if (lng.length > 0) return lng[0].language;
        else return "";
    };


    return (
        <>
            <p className="text-center text-xl font-bold pt-2 pb-2"> Settings </p>
            <div className="p-8">
                <Stack
                    title={t('header.tooltip.language')}
                    onClick={() => setMenuLang(!menuLang)}
                    sx={{ cursor: 'pointer', marginTop: '12px' }}
                    direction="row"
                    spacing={2}
                    alignItems="center"
                >
                    <TranslateIcon
                        className="_cp"
                        sx={{ fontSize: '18px', color: '#999999' }}
                    />
                    <Typography className="fs-14 _cp" sx={{ color: '#999999' }}>
                        {getCode()}
                    </Typography>
                    <img
                        src={Images.arrowdown}
                        style={{
                            width: '30px',
                            transform: menuLang ? 'rotate(180deg)' : 'rotate(0deg)',
                        }}
                        className="____transform"
                        alt=""
                    />
                </Stack>

                {menuLang && (
                        <Box
                            sx={{
                                background: '#171515',
                                width: 'max-content',
                                zIndex: 10000000000000,
                                padding: '8px 15px',
                                borderRadius: '6px',
                            }}
                        >
                            {availableLanguages.map((language, index) => (
                                <Typography
                                    key={index}
                                    onClick={() => handleLangChange(language['code'])}
                                    className="fs-14 _cp p5"
                                    sx={{
                                        color: language === language['code'] ? 'blue' : 'white',
                                    }}
                                >
                                    {language?.language}
                                </Typography>
                            ))}
                        </Box>
                ) }
            </div>
        </>
    )
}
